import { PopoverContentContainer, PopoverRoot } from '@/components/Popover';
import { usePopover } from '@/hooks/popover/usePopover';
import styled from '@emotion/styled';
import { FloatingArrow } from '@floating-ui/react';

const Guideline = styled.span`
    text-decoration: underline;
    cursor: pointer;
`;

const StyledPopoverContentContainer = styled(PopoverContentContainer.withComponent('ul'))`
    max-width: 400px;

    gap: 8px;

    list-style-type: disc;

    li {
        margin-inline-start: 12px;
    }
`;

interface Props {
    maxFilesUpload: number;
}

export const UploadGuideline = ({ maxFilesUpload }: Props) => {
    const { isPopoverOpen, refs, floatingStyles, getFloatingProps, getReferenceProps, arrowProps } = usePopover({
        type: 'hover',
        options: { placement: 'top' },
        offsetOptions: { mainAxis: 5 },
    });

    return (
        <>
            <Guideline ref={refs.setReference} {...getReferenceProps()}>
                Guideline to upload your files
            </Guideline>
            {isPopoverOpen && (
                <PopoverRoot ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
                    <FloatingArrow {...arrowProps} />
                    <StyledPopoverContentContainer>
                        <li>You can upload up to {maxFilesUpload} documents. Check that they are correct and up to date.</li>
                        <li>The maximum allowed characters per document is 500,000.</li>
                        <li>Text should be in a single column using paragraphs, like an article.</li>
                        <li>Text in tables may not be read correctly. Try pulling text from tables and writing them as paragraphs.</li>
                        <li>Formatting, styles, and images are ignored.</li>
                        <li>Using a Q&A structure is highly encouraged for better search ability and relevance in retrieval</li>
                    </StyledPopoverContentContainer>
                </PopoverRoot>
            )}
        </>
    );
};
